import classNames from 'classnames/bind';

import style from './RadioButton.module.scss';
const cx = classNames.bind(style);

type RadioButtonProps = {
  active: boolean;
  label: string;
  value?: string;
  className?: string;
  onClick: (value: string) => void;
};

export default function RadioButton(props: RadioButtonProps) {
  const { active, label, onClick, value, className } = props;

  return (
    <button
      className={cx(["radio-button", className, { active }])}
      type="button"
      onClick={() => onClick(value || label)}
    >
      <span className={cx("circle")} />
      <p className="text-m">{label}</p>
    </button>
  );
}
